import { inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { AdminAuthService } from '@app/services/admin-auth/admin-auth.service';
import {
  AdminBootstrapService,
  BootstrapData,
} from '@app/services/admin-bootstrap/admin-bootstrap.service';
import { catchError, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminBootstrapResolver implements Resolve<BootstrapData> {
  adminAuthService = inject(AdminAuthService);
  bootstrapService = inject(AdminBootstrapService);

  resolve(): Observable<BootstrapData> {
    return this.bootstrapService.initializeApp().pipe(
      catchError((error) => {
        console.warn(error);
        this.adminAuthService.signOutAndRedirect();
        return of(null);
      })
    );
  }

  refresh(): Observable<BootstrapData> {
    return this.bootstrapService.initializeApp({ forceRefresh: true }).pipe(
      catchError((error) => {
        console.warn(error);
        this.adminAuthService.signOutAndRedirect();
        return of(null);
      })
    );
  }
}
